import ArrowLeft from '@crehana/compass.icons.outline/ArrowLeft';
import { Breadcrumb } from '@crehana/compass.ui/breadcrumb';
import { useLocation, useNavigate, useParams } from '@/shared/modern-router';
import { useConfiguration } from '../../context/Configuration/context';
import { useTranslation } from './hooks';

const HeaderRedirectButtons = () => {
  const { t } = useTranslation();
  const { setTracking } = useConfiguration();
  const { processId, activityId, userId, slug } = useParams<{
    processId: string;
    activityId: string;
    userId: string;
    slug: string;
  }>();

  const rootPath = `/org/${slug}/talent/panel/employee`;
  const excludedPaths: string[] = [
    'talent',
    'panel',
    'employee',
    'tracking',
    'my_team',
    'users',
    'activities',
    processId as string,
    userId as string,
    activityId as string,
  ];
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const items =
    pathname
      ?.replace(rootPath, '')
      .replace(/-/g, '_')
      .split('/')
      .filter(Boolean)
      .filter(p => !excludedPaths.includes(p))
      .map((path, index, array) => {
        let href;
        if (index === 0 || index === 1) {
          href = `${rootPath}/performance/pid/${processId}`;
        } else if (index === 2) {
          href = `${rootPath}/performance/pid/${processId}/activity/${activityId}`;
        } else {
          href = `${rootPath}${array.slice(0, 1 + index).join('/')}`;
        }
        return {
          text: t(path as 'performance' | 'pid' | 'activity'),
          href: href,
        };
      }) || [];

  const handleBack = () => {
    setTracking(undefined);
    if (pathname?.includes('/my-team') && processId) {
      navigate._originalNavigate(
        `${rootPath}/performance/pid/${processId}/my-team`,
      );
    } else {
      navigate.goBack();
    }
  };

  return (
    <div className="tw-mx-0 tw-px-0">
      <div className="tw-w-full tw-mb-[3.4rem]">
        <Breadcrumb items={items} />
      </div>
      <div className="tw-w-full tw-flex tw-items-center tw-pb-3.2 tw-justify-between">
        <div className="tw-inline-block">
          <div>
            <button
              type="button"
              className="tw-text-link-m tw-btn-icon"
              onClick={handleBack}
            >
              <ArrowLeft className="tw-text-primary-light-500" size={24} />
              {t('RETURN_PANEL')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeaderRedirectButtons;
